<template>
  <!-- ============================================================
       会议室订单筛选面板（全站统一 · 销售端方案）
       ------------------------------------------------------------
       维度与顺序对齐销售端「会议室订单 → 筛选」（pages/client.vue 662-890）：
         ① 使用时间（日期区间滚轮） ② 时段 chips ③ 是否收费 chips
         ④ 审核状态 chips ⑤ 门店（滚轮选择） ⑥ 会议室（滚轮选择）
         ⑦ 客户 ⑧ 商机 ⑨ 销售合同 ⑩ 财务合同（均为可搜索选择器）
       【P419-c】⑤⑥ 由「会议室 → 门店」改为「门店 → 会议室」：会议室按门店联动，
         依赖项排前面，用户不会先点会议室再被提示去选门店。
       与销售端的唯一差异（且是修正）：销售端的「会议室」取 client/roomOrder/getFormData
         的 d.meeting_room / d.rooms，实测该接口**不返回会议室列表** ⇒ 选项恒空。
         这里改用 /getRooms{storeSN, roomDateRangeValue}，并按门店做二级联动。
       ============================================================ -->
  <div class="rfp">
    <van-popup
      :value="value"
      position="bottom"
      round
      :style="{ height: '84%' }"
      @input="v => $emit('input', v)"
    >
      <div class="bill-filter">
        <div class="bill-filter__hd">
          <span class="bill-filter__title">{{ title || '筛选会议室订单' }}</span>
          <van-icon name="cross" class="bill-sheet__close" @click="$emit('input', false)" />
        </div>

        <div class="bill-filter__bd">
          <div class="bill-filter__group" v-for="f in defs" :key="f.prop">
            <div class="bill-filter__label">
              <span>{{ f.label }}</span>
              <span class="bill-filter__reset" v-if="on(f)" @click="clearOne(f)">清除</span>
            </div>

            <!-- ① 日期区间（使用时间） -->
            <div class="bill-filter__range" v-if="f.type === 'daterange'">
              <div class="bill-filter__pick"
                   :class="{ 'bill-filter__pick--on': !!draft[f.beginKey] }"
                   @click="openDate(f.beginKey, f.label + '开始')">{{ draft[f.beginKey] || '开始日期' }}</div>
              <span class="bill-filter__sep">~</span>
              <div class="bill-filter__pick"
                   :class="{ 'bill-filter__pick--on': !!draft[f.endKey] }"
                   @click="openDate(f.endKey, f.label + '结束')">{{ draft[f.endKey] || '结束日期' }}</div>
            </div>

            <!-- ②③④ chips -->
            <div class="bill-filter__chips" v-else-if="f.type === 'chips'">
              <span class="bill-filter__chip"
                    :class="{ 'bill-filter__chip--on': !on(f) }"
                    @click="setDraft(f.prop, '')">全部</span>
              <span class="bill-filter__chip"
                    v-for="o in f.options"
                    :key="'c' + f.prop + o.value"
                    :class="{ 'bill-filter__chip--on': String(draft[f.prop]) === String(o.value) }"
                    @click="setDraft(f.prop, o.value)">{{ o.label }}</span>
            </div>

            <!-- ⑤⑥ 会议室 / 门店：滚轮（可搜索选择器） -->
            <div class="bill-filter__pick bill-filter__pick--full"
                 v-else-if="f.type === 'wheel'"
                 :class="{ 'bill-filter__pick--on': !!draft[f.prop] }"
                 @click="openWheel(f)">
              <span class="bill-filter__picktx">{{ pickText(f) }}</span>
              <van-icon name="arrow" class="bill-filter__arrow" />
            </div>

            <!-- ⑦⑧⑨⑩ 客户 / 商机 / 销售合同 / 财务合同 -->
            <div class="bill-filter__pick bill-filter__pick--full"
                 v-else
                 :class="{ 'bill-filter__pick--on': !!draft[f.prop] }"
                 @click="openSheet('remote', f)">
              <span class="bill-filter__picktx">{{ pickText(f) }}</span>
              <van-icon name="arrow" class="bill-filter__arrow" />
            </div>
          </div>
        </div>

        <div class="bill-filter__ft">
          <div class="btn-action btn-action--secondary" @click="resetAll"><span>重置</span></div>
          <div class="btn-action btn-action--primary" @click="apply"><span>确定</span></div>
        </div>
      </div>
    </van-popup>

    <!-- ===== 日期滚轮 ===== -->
    <van-popup v-model="dateShow" position="bottom" round>
      <van-datetime-picker
        type="date"
        :title="dateTitle"
        :value="dateCur"
        :min-date="dateMin"
        :max-date="dateMax"
        @cancel="dateShow = false"
        @confirm="onDateConfirm"
      />
    </van-popup>

    <!-- ===== 选项弹层（门店 / 会议室 / 远程选择器 三合一） ===== -->
    <van-popup v-model="sheetShow" position="bottom" :style="{ height: '72%' }" round>
      <div class="bill-picker">
        <div class="bill-picker__hd">
          <span class="bill-picker__title">{{ sheetTitle }}</span>
          <van-icon name="cross" class="bill-sheet__close" @click="sheetShow = false" />
        </div>
        <div class="bill-picker__search">
          <van-icon name="search" class="bill-picker__kwico" />
          <input class="bill-picker__kwin" v-model="sheetKeyword"
                 :placeholder="sheetPlaceholder"
                 @input="onSheetInput" />
          <van-icon name="clear" class="bill-picker__kwclr" v-if="sheetKeyword" @click="clearSheetKw" />
        </div>
        <div class="bill-picker__bd">
          <div class="bill-picker__item"
               :class="{ 'bill-picker__item--on': !draft[sheetProp] }"
               @click="pickSheet('')">
            <div class="bill-picker__nm">{{ sheetAllText }}</div>
          </div>
          <div class="bill-picker__item"
               v-for="o in sheetList"
               :key="'sk' + o.value"
               :class="{ 'bill-picker__item--on': String(draft[sheetProp]) === String(o.value) }"
               @click="pickSheet(o)">
            <div class="bill-picker__nm">{{ o.text }}</div>
            <div class="bill-picker__sub" v-if="o.sub">{{ o.sub }}</div>
          </div>
          <div class="bill-sheet__loading" v-if="sheetLoading">加载中…</div>
          <div class="bill-sheet__loading" v-else-if="!sheetList.length">{{ sheetEmpty }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
/* ============================================================================
 * RoomFilter —— 会议室订单筛选面板（全站统一）
 * ----------------------------------------------------------------------------
 * 【契约】
 *   props : value(v-model 显隐) / applied(已生效值) / appliedMeta(已生效值的显示名) /
 *           apiPrefix(client|operation|market|finance) / title
 *   emits : input(显隐) / apply(payload, labels, meta)
 *   payload 键名（与后端 BillListService.types()['room'].filters 对齐）：
 *     on_site_time_begin / on_site_time_end / time_type / is_free / approval_tab /
 *     room_sn（= meeting_room_sn 列，后端已同时接受 meeting_room_sn 别名）/
 *     stores_sn / customer_sn / opportunitie_sn / parent_sn / contracts_sn
 *
 * 【meta 的作用】
 *   门店/会议室/远程选择器存的是 sn，界面要显示中文名。若只传 sn，
 *   下次打开面板或顶部「已生效筛选」状态条就只能显示「已选」。
 *   故父级把 { prop: 中文名 } 一起存下来（meta），随 applied 一起回传。
 *
 * 【二级联动】
 *   会议室依赖门店：未选门店时点「会议室」→ 提示先选门店（/getRooms 无门店恒返回空，
 *   这是接口硬约束，不是交互偷懒）；切换门店会清空已选会议室，避免「门店=A，会议室属于B」
 *   的矛盾条件导致列表恒空。
 * ========================================================================== */
/* 【P419】四端数据源分流。为什么不能全用根域接口：
 *   · 根域 getStores/getRooms（销售端那条）走的是 client 应用的鉴权与上下文；
 *   · 运营端 app/operation、市场端 app/market、财务端 app/finance 是**各自独立的应用**，
 *     只有各自的 <prefix>/getStores、<prefix>/getRooms 才保证可用（市场端实测 19 家门店 / 14 间会议室）；
 *   · 财务端连 getStores 路由都没有，用的是 P187 的 storesOptions / roomsOptions（参数名也不同：
 *     searchText + stores_sn，返回 {list:[{value,text,sub}]}）。
 *   ⇒ 这里按 apiPrefix 分流，并对返回结构做归一（见 loadSheet）。
 */
import {
  getStores,
  getRooms,
  getBillFilterOptionsData,
  getOperationBillFilterOptionsData,
  getMarketBillFilterOptionsData,
  operationGetStores,
  operationGetRooms
} from '../api/api.js'
/* 市场端：/market/getStores、/market/getRooms（委托 admin:StatisticsRoomController，与销售端同源同参） */
import { getStores as marketGetStores, getRooms as marketGetRooms } from '../api/market.js'
/* 财务端：/finance/storesOptions、/finance/roomsOptions、/finance/filterRefOptions（P187 既有能力） */
import { financeStoresOptions, financeRoomsOptions, financeFilterRefOptions } from '../api/finance.js'

function ymd(d) {
  if (!d) return ''
  if (typeof d === 'string') return d.slice(0, 10)
  const p = (n) => (n < 10 ? '0' + n : '' + n)
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}

/* 筛选维度定义（顺序即销售端顺序，勿随意调整） */
const DEFS = [
  { prop: 'on_site_time', label: '使用时间', type: 'daterange',
    beginKey: 'on_site_time_begin', endKey: 'on_site_time_end' },
  { prop: 'time_type', label: '时段', type: 'chips', options: [
    { value: 1, label: '全天' }, { value: 2, label: '白天' }, { value: 3, label: '上午' },
    { value: 4, label: '下午' }, { value: 5, label: '晚上' }, { value: 6, label: '小时' },
    { value: 7, label: '下午+晚上' }
  ] },
  { prop: 'is_free', label: '是否收费', type: 'chips', options: [
    { value: 1, label: '收费' }, { value: 2, label: '免费' }
  ] },
  { prop: 'approval_tab', label: '审核状态', type: 'chips', options: [
    { value: 2, label: '审核中' }, { value: 3, label: '审核通过' }, { value: 5, label: '审核驳回' }
  ] },
  /* 【P419-c】门店放在会议室上面（用户 10-22 13:44 要求）。
     ① 逻辑上本来就该这样：会议室按门店联动，未选门店时点会议室会被拦截，
        把依赖项排在前面，用户不会先撞一次提示；
     ② 视觉上两个滚轮选择器相邻，门店→会议室的阅读顺序与操作顺序一致。 */
  { prop: 'stores_sn', label: '门店', type: 'wheel', allText: '全部门店' },
  { prop: 'room_sn', label: '会议室', type: 'wheel', allText: '全部会议室' },
  { prop: 'customer_sn', label: '客户', type: 'remote', kind: 'customer', allText: '全部客户' },
  { prop: 'opportunitie_sn', label: '商机', type: 'remote', kind: 'opportunity', allText: '全部商机' },
  { prop: 'parent_sn', label: '销售合同', type: 'remote', kind: 'sales_contract', allText: '全部销售合同' },
  { prop: 'contracts_sn', label: '财务合同', type: 'remote', kind: 'finance_contract', allText: '全部财务合同' }
]

export default {
  name: 'RoomFilter',
  props: {
    value: { type: Boolean, default: false },
    applied: { type: Object, default: () => ({}) },
    appliedMeta: { type: Object, default: () => ({}) },
    apiPrefix: { type: String, default: 'operation' },
    title: { type: String, default: '' }
  },
  data() {
    return {
      defs: DEFS,
      draft: {},
      meta: {},
      /* 日期滚轮 */
      dateShow: false,
      dateKey: '',
      dateTitle: '选择日期',
      dateCur: new Date(),
      dateMin: new Date(2018, 0, 1),
      dateMax: new Date(2032, 11, 31),
      /* 三合一选项弹层 */
      sheetShow: false,
      sheetType: '',      // store | room | remote
      sheetProp: '',
      sheetTitle: '',
      sheetPlaceholder: '搜索',
      sheetAllText: '全部',
      sheetKeyword: '',
      sheetList: [],
      sheetLoading: false,
      sheetEmpty: '暂无可选项',
      /* 会议室原始列表缓存（按门店，切换门店即废弃） */
      roomRaw: []
    }
  },
  watch: {
    value(v) {
      if (v) this.openPanel()
    }
  },
  methods: {
    /* ---------------- 打开面板：回填 ---------------- */
    openPanel() {
      this.draft = Object.assign({}, this.applied || {})
      this.meta = Object.assign({}, this.appliedMeta || {})
    },
    setDraft(k, v) {
      /* Vue2 对实例化后新增属性不做响应式劫持 → 必须 $set，否则「点了没反应」 */
      this.$set(this.draft, k, v)
    },
    on(f) {
      if (f.type === 'daterange') return !!this.draft[f.beginKey] || !!this.draft[f.endKey]
      const v = this.draft[f.prop]
      return !(v === undefined || v === null || v === '')
    },
    clearOne(f) {
      if (f.type === 'daterange') {
        this.setDraft(f.beginKey, '')
        this.setDraft(f.endKey, '')
        return
      }
      this.setDraft(f.prop, '')
      this.$set(this.meta, f.prop, '')
      /* 清门店时，会议室的联动前提没了 → 一并清掉（否则残留矛盾条件） */
      if (f.prop === 'stores_sn') {
        this.setDraft('room_sn', '')
        this.$set(this.meta, 'room_sn', '')
        this.roomRaw = []
      }
    },
    pickText(f) {
      const name = this.meta[f.prop]
      if (name) return name
      const v = this.draft[f.prop]
      if (v === undefined || v === null || v === '') return f.allText || '全部'
      return '已选 1 项'
    },

    /* ---------------- 日期滚轮 ---------------- */
    openDate(key, title) {
      this.dateKey = key
      this.dateTitle = title || '选择日期'
      const cur = this.draft[key]
      this.dateCur = cur ? new Date(String(cur).slice(0, 10).replace(/-/g, '/')) : new Date()
      this.dateShow = true
    },
    onDateConfirm(v) {
      if (this.dateKey) this.setDraft(this.dateKey, ymd(v))
      this.dateShow = false
    },

    /* ---------------- 接口分流（client / operation / market / finance） ---------------- */
    storesApi(p) {
      const pre = this.apiPrefix
      /* 财务端参数名是 searchText，无分页（后端 limit 50） */
      if (pre === 'finance') return financeStoresOptions({ searchText: p.searchText || '' })
      if (pre === 'market') {
        return marketGetStores({ searchText: p.searchText || '', page: p.page || 1, pageSize: p.pageSize || 50 })
      }
      if (pre === 'operation') return operationGetStores(p)
      return getStores(p)
    },
    roomsApi(p) {
      const pre = this.apiPrefix
      /* 财务端：搜索结果由服务端按 searchText 过滤，无门店时传空（后端会返回全量 191 条，可用但不精准） */
      if (pre === 'finance') {
        return financeRoomsOptions({ searchText: '', stores_sn: p.storeSN || '' })
      }
      if (pre === 'market') return marketGetRooms(p)
      if (pre === 'operation') return operationGetRooms(p)
      return getRooms(p)
    },
    optionsApi(p) {
      const pre = this.apiPrefix
      if (pre === 'operation') return getOperationBillFilterOptionsData(p)
      /* 【P419】市场端此前无此路由（只能借 client，而 client 按本人归属收敛 ⇒ 选项恒空）；
         本轮新开 market/billFilterOptions，委托 client 且 _marketAll=true ⇒ 全量口径。 */
      if (pre === 'market') return getMarketBillFilterOptionsData(p)
      /* 财务端复用 P187 的 filterRefOptions（参数名 keyword → searchText） */
      if (pre === 'finance') {
        return financeFilterRefOptions({ kind: p.kind, searchText: p.keyword || '', pageSize: 50 })
      }
      return getBillFilterOptionsData(p)
    },

    /* ---------------- 打开选项弹层 ---------------- */
    openWheel(f) {
      if (f.prop === 'room_sn' && !this.draft.stores_sn) {
        /* /getRooms 无门店入参恒返回空（实测 n=0），故必须先选门店 —— 这正是二级联动的落点 */
        this.$toast('请先选择门店，会议室按门店联动')
        return
      }
      this.openSheet(f.prop === 'stores_sn' ? 'store' : 'room', f)
    },
    openSheet(type, f) {
      this.sheetType = type
      this.sheetProp = f.prop
      this.sheetTitle = f.label
      this.sheetAllText = f.allText || '全部'
      this.sheetKeyword = ''
      this.sheetList = []
      this.sheetPlaceholder = '搜索' + f.label
      this.sheetEmpty = '暂无可选项'
      this.sheetShow = true
      this.loadSheet()
    },
    onSheetInput() {
      clearTimeout(this.__skTimer)
      /* 门店/远程走服务端搜索（数据量大）；会议室在门店内本地过滤（单店仅十余个） */
      this.__skTimer = setTimeout(() => this.loadSheet(), 260)
    },
    clearSheetKw() {
      this.sheetKeyword = ''
      this.loadSheet()
    },
    loadSheet() {
      const kw = (this.sheetKeyword || '').trim()
      this.sheetLoading = true
      if (this.sheetType === 'store') {
        this.storesApi({ searchText: kw, page: 1, pageSize: 50 }).then(res => {
          this.sheetLoading = false
          const d = res && res.code === 200 ? res.data : null
          /* 归一四种形态：数组 / {data:[]} / {list:[]}（财务端） */
          const arr = Array.isArray(d) ? d
                    : ((d && Array.isArray(d.data)) ? d.data
                    : ((d && Array.isArray(d.list)) ? d.list : []))
          this.sheetList = arr.map(x => ({
            value: x.sn || x.value || '',
            text: x.title || x.name || x.text || '',
            sub: (x.title && x.name) ? x.name : (x.sub || '')
          }))
          this.sheetEmpty = '暂无门店'
        }).catch(() => { this.sheetLoading = false; this.sheetEmpty = '门店加载失败' })
        return
      }
      if (this.sheetType === 'room') {
        const storeSn = this.draft.stores_sn
        if (!this.roomRaw.length) {
          /* 财务端返回 {list:[{value,text,sub}]}，其余端返回 {rooms:[{sn,name,room_number}]} */
          const isFin = this.apiPrefix === 'finance'
          const req = isFin
            ? this.roomsApi({ storeSN: storeSn })
            : this.roomsApi({ storeSN: storeSn, roomDateRangeValue: [ymd(new Date()), ymd(new Date())] })
          req.then(res => {
            this.sheetLoading = false
            const d = res && res.code === 200 ? res.data : null
            if (isFin) {
              const arr = (d && Array.isArray(d.list)) ? d.list : []
              this.roomRaw = arr.map(x => ({ sn: x.value, name: x.text, room_number: '' }))
            } else {
              this.roomRaw = (d && Array.isArray(d.rooms)) ? d.rooms : []
            }
            this.applyRoomFilter(kw)
          }).catch(() => { this.sheetLoading = false; this.sheetEmpty = '会议室加载失败' })
          return
        }
        this.sheetLoading = false
        this.applyRoomFilter(kw)
        return
      }
      /* remote */
      const kind = (DEFS.find(x => x.prop === this.sheetProp) || {}).kind || ''
      this.optionsApi({ kind: kind, keyword: kw }).then(res => {
        this.sheetLoading = false
        const d = res && res.code === 200 ? res.data : null
        const arr = (d && Array.isArray(d.list)) ? d.list : []
        this.sheetList = arr.map(x => ({ value: x.value, text: x.text, sub: x.sub }))
        this.sheetEmpty = '暂无可选项'
      }).catch(() => { this.sheetLoading = false; this.sheetEmpty = '加载失败' })
    },
    applyRoomFilter(kw) {
      const low = String(kw || '').toLowerCase()
      this.sheetList = this.roomRaw
        .filter(r => {
          if (!low) return true
          const txt = String(r.room_number || '') + String(r.name || '')
          return txt.toLowerCase().indexOf(low) >= 0
        })
        .map(r => ({
          value: r.sn,
          text: r.room_number || r.name || '',
          sub: r.room_number && r.name ? r.name : ''
        }))
      this.sheetEmpty = this.draft.stores_sn ? '该门店暂无会议室' : '请先选择门店'
    },
    pickSheet(o) {
      const prop = this.sheetProp
      if (o === '') {
        this.setDraft(prop, '')
        this.$set(this.meta, prop, '')
        this.sheetShow = false
        if (prop === 'stores_sn') {
          this.setDraft('room_sn', '')
          this.$set(this.meta, 'room_sn', '')
          this.roomRaw = []
        }
        return
      }
      this.setDraft(prop, o.value)
      this.$set(this.meta, prop, o.text)
      this.sheetShow = false
      /* 换门店 → 清已选会议室（跨门店的会议室条件必然筛不到数据） */
      if (prop === 'stores_sn') {
        this.roomRaw = []
        if (this.draft.room_sn) {
          this.setDraft('room_sn', '')
          this.$set(this.meta, 'room_sn', '')
        }
      }
    },

    /* ---------------- 重置 / 确定 ---------------- */
    resetAll() {
      this.draft = {}
      this.meta = {}
      this.roomRaw = []
    },
    apply() {
      const next = {}
      Object.keys(this.draft).forEach(k => {
        const v = this.draft[k]
        if (v !== undefined && v !== null && v !== '') next[k] = v
      })
      const labels = this.labelsOf(next)
      this.$emit('input', false)
      this.$emit('apply', next, labels, Object.assign({}, this.meta))
    },
    labelsOf(next) {
      const out = []
      this.defs.forEach(f => {
        if (f.type === 'daterange') {
          const b = next[f.beginKey]
          const e = next[f.endKey]
          if (b) out.push(f.label + '起：' + b)
          if (e) out.push(f.label + '止：' + e)
          return
        }
        const cur = next[f.prop]
        if (cur === undefined || cur === null || cur === '') return
        if (f.type === 'chips') {
          const o = (f.options || []).find(x => String(x.value) === String(cur))
          out.push(f.label + '：' + (o ? o.label : cur))
          return
        }
        out.push(f.label + '：' + (this.meta[f.prop] || cur))
      })
      return out
    }
  }
}
</script>

<style scoped>
/* 子节点均为 fixed 定位 popup，本包裹层无视觉影响；保留以承载 scoped 作用域 */
.rfp {
  --bill-brand: var(--brand, #2b5fd9);
  --bill-brand-soft: var(--brand-soft, #eef2fb);
}
</style>



// WEBPACK FOOTER //
// src/components/RoomFilter.vue